import React from 'react';
import { Box, Typography, List, ListItemButton, ListItemText, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';

const SubmenuContainer = styled(Box)(({ theme }) => ({
  width: 200,
  height: '100vh',
  backgroundColor: '#FFFFFF',
  borderRight: '1px solid #E2E8F0',
  position: 'fixed',
  left: 80,
  top: 0,
  zIndex: 900,
  paddingTop: theme.spacing(3),
}));

const SubmenuHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 2, 2, 2),
}));

const BillingSubmenu: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { label: 'Subscriptions', path: '/billing' },
    { label: 'Promo Chains', path: '/billing/promos' },
  ];

  return (
    <SubmenuContainer>
      <SubmenuHeader>
        <Typography variant="h6" fontWeight="bold" color="textPrimary">
          Billing
        </Typography>
        <Typography variant="caption" color="textSecondary">
          Revenue & Discounts
        </Typography>
      </SubmenuHeader>
      <Divider sx={{ mb: 1 }} />
      <List component="nav" sx={{ px: 1 }}>
        {menuItems.map((item) => (
          <ListItemButton
            key={item.path}
            selected={location.pathname === item.path}
            onClick={() => navigate(item.path)}
            sx={{
              borderRadius: 1,
              mb: 0.5,
              '&.Mui-selected': {
                backgroundColor: '#F0EFFF',
                color: '#6B46C1',
                '&:hover': {
                  backgroundColor: '#E5E4FF',
                },
              },
            }}
          >
            <ListItemText 
              primary={item.label} 
              primaryTypographyProps={{ 
                fontSize: '0.875rem',
                fontWeight: location.pathname === item.path ? 'bold' : 'medium'
              }} 
            />
          </ListItemButton>
        ))}
      </List>
    </SubmenuContainer>
  );
};

export default BillingSubmenu;
